import { Link } from 'react-router-dom'
import './App.css'

function Launcher() {
    const ENABLE_WRITE = process.env.REACT_APP_ENABLE_WRITE !== 'false';
    const ENABLE_ANNOTATE = process.env.REACT_APP_ENABLE_ANNOTATE === 'true';

    return (
        <div className="launcher-container">
            <h1 className="launcher-title">
                Collapoet
            </h1>
            <h1 className={"launcher-subtitle"}>
                Human-AI Collaborative Poetry Platform
            </h1>
            <div className="launcher-buttons">
                {ENABLE_WRITE && (
                    <Link to="/start?mode=write" className="launcher-button">
                        ✍️ <span>Write a Poem</span>
                    </Link>
                )}

                {ENABLE_ANNOTATE && (
                    <Link to="/start?mode=annotate" className="launcher-button">
                        ⚖️ <span>Annotate Poems</span>
                    </Link>
                )}
            </div>
        </div>
    );
}
export default Launcher;
